<template>
  <div :class="{ MasterclassOffer: true, 'MasterclassOffer--small': $mq === 'mobile', 'Last': this.index == 2 }">
    <img :src="background" class="Background" />
    <img :src="topImage" class="TopImage" />

    <div class="OfferTitle">
      <div class="OfferTitle-Title Main">
        {{ mainTitle }}
      </div>
      <div class="OfferTitle-Title Sub" v-if="this.index == 1 || this.index == 2">
        {{ this.index == 1 ? t('two-bottles') : t('four-bottles') }}
      </div>
    </div>

    <div class="OfferContent">
      <div class="OfferContentIntro">
        <img src="@/assets/shop/masterclass/check.png" class="OfferPicto" />
        <p>{{ t('formation', { name: masterclass.title }) }}</p>
      </div>
      <div class="OfferContentDescription">
        <img src="@/assets/shop/masterclass/not.png" class="OfferPicto" v-if="this.index == 0" />
        <img src="@/assets/shop/masterclass/check.png" class="OfferPicto" v-else />
        <div class="OfferContentDescriptionContainer">
          <div :class="['OfferContentDescriptionContainerFirst', this.index == 0 ? 'FirstOffer' : '']">
            {{ bottleOffer }}
          </div>
          <div class="OfferContentDescriptionContainerSub">
            <p v-html="shopifyMasterclass.descriptionHtml"></p>
          </div>
        </div>
      </div>
    </div>

    <div class="ButtonWrapper">
      <div v-if="$mq === 'mobile'" class="Price">
        <b>{{ shopifyMasterclass.variants[0].price }}€</b>
      </div>
      <div class="Buttons">
        <div class="Button"
          @click="onOffer"
          v-if="!shopLoading"
        >
          Offrir
        </div>
        <div class="Button" @click="onBuy" v-if="!shopLoading">
          {{ t('buy') }}
        </div>
        <div class="Loader-Wrapper" v-if="shopLoading">
          <loader />
        </div>
      </div>

      <div v-if="$mq !== 'mobile'" class="Price">
        {{ shopifyMasterclass.variants[0].price }}€
      </div>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get'
import Loader from "@/components/common/Loader";
import { mapGetters } from 'vuex'

export default {
  name: 'MasterclassOffer',
  components: {Loader},
  props: {
    shopifyMasterclass: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    ...mapGetters([
      'getThemeById'
    ]),
    shopLoading() {
      return this.$store.state.shop.isLoading
    },
    masterclass() {
      return this.getThemeById(this.$route.params.productId)
    },
    background() {
      const image = this.$mq === 'mobile' ? `Mobile` : `Desktop`

      return require(`@/assets/shop/masterclass/${image}.png`)
    },
    topImage() {
      return require(`@/assets/shop/masterclass/Learn-${this.index}.png`)
    },
    mainTitle() {
      return this.index == 0 ? this.t('learn') : this.t('learn-taste')
    },
    bottleOffer() {
      switch (this.index) {
        case 0:
          return this.t('bottles.none')
        case 1:
          return this.t('bottles.two')
        case 2:
          return this.t('bottles.four')
        default:
          return null
      }
    }
  },
  methods: {
    t(key, params) {
      return this.$t(`shop.masterclass-offer.${key}`, params)
    },
    onBuy() {
      this.$emit('click', this.index)
    },
    onOffer() {
      this.$emit('propagate-show-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.MasterclassOffer {
  display: inline-block;
  position: relative;
  text-align: left;
  font-size: 12px;
  max-width: 250px;
  max-height: 400px;
  margin-left: 2%;
  margin-right: 2%;

  .Background {
    height: 300px;
    width: 250px;
  }

  .TopImage {
    width: 100px;
    position: relative;
    top: -370px;
    left: 75px;
  }

  .OfferTitle {
    position: relative;
    display: block;
    top: -350px;
    // text-align: center;
    left: 0px;
    color: $primary;
    font-weight: bold;
    font-family: Helvetica, sans-serif;

    .Main {
      font-size: 20px;
      text-align: center;
    }

    .Sub {
      font-size: 15px;
      text-align: center;
    }
  }

  .OfferPicto {
    width: 20px;
    height: 20px;
    // height: auto;
  }

  .OfferContent {
    max-width: 200px;
    position: absolute;
    left: 30px;
    top: 115px;

    .OfferContentIntro {
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        font-family: Helvetica, sans-serif;
        font-size: 12px;
        margin-left: 20px;
      }
    }

    .OfferContentDescription {
      display: flex;
      justify-content: flex-start;

      .OfferContentDescriptionContainer {
        margin-left: 20px;

        .OfferContentDescriptionContainerFirst {
          font-family: Helvetica, sans-serif;
        }

        .OfferContentDescriptionContainerFirst.FirstOffer {
          color: #A2A1A1;
        }

        .OfferContentDescriptionContainerSub p {
          font-style: italic;
          font-size: 10px;
        }
      }
    }
  }

  .ButtonWrapper {
    position: absolute;
    // top: 0px;
    bottom: 50px;
    left: 35px;
    text-align: center;
    max-width: 250px;
    width: 175px;

    .Loader-Wrapper {
      position: absolute;
      left: 45%;
      top: -40px;

      @media (max-width: 450px) {
        top: -30px;
      }
    }

    .Buttons {
      display: flex;
      justify-content: center;
    }

    .Button {
      cursor: pointer;
      display: inline-block;
      padding: 8px 10px;
      font-weight: bold;
      background-color: $primary;
      border-radius: 23px;
      text-transform: uppercase;
      color: white;
      margin-bottom: 12px;

      &:first-of-type {
        margin-right: 15px;
      }
    }

    .Price {
      font-size: 18px;
    }
  }

  &--small {
    .Background {
      height: 200px;
      width: 100%;
    }

    .TopImage {
      width: 70px;
      position: relative;
      top: -155px;
      left: 25px;
    }

    .OfferTitle {
      position: relative;
      display: block;
      top: -150px;
      text-align: left;
      left: -62px;
      color: $primary;
      font-weight: bold;
      font-family: Helvetica, sans-serif;

      .Main {
        font-size: 10px;
        text-align: center;
      }

      .Sub {
        font-size: 8px;
        text-align: center;
      }
    }

    .OfferPicto {
      width: 20px;
      height: 20px;
      // height: auto;
    }

    .OfferContent {
      max-width: 130px;
      position: absolute;
      left: 100px;
      top: 5px;

      .OfferContentIntro {
        display: flex;
        justify-content: center;
        align-items: center;

        p {
          font-family: Helvetica, sans-serif;
          font-size: 10px;
          margin-left: 20px;
        }
      }

      .OfferContentDescription {
        display: flex;
        justify-content: flex-start;

        .OfferContentDescriptionContainer {
          margin-left: 15px;

          .OfferContentDescriptionContainerFirst.FirstOffer {
            color: #A2A1A1;
          }

          .OfferContentDescriptionContainerFirst {
            font-size: 10px;
          }

          .OfferContentDescriptionContainerSub p {
            font-style: italic;
            font-size: 8px;
            margin-top: 0;
          }
        }
      }
    }


    .ButtonWrapper {
      left: 55px;
      bottom: 75px;

      .Price {
        font-size: 14px;
        margin-bottom: 8px;
      }
    }

    &.Last {
      .Background {
        height: 215px;
      }

      .TopImage {
        top: -180px;
      }

      .OfferTitle {
        top: -165px;
      }
    }
  }
}
</style>
